abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.page_block = abcsetup.promos.page_block || {};
abcsetup.promos.page_block.edit = abcsetup.promos.page_block.edit || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.page_block.edit = { 
    init: function() {
        abcsetup.setTitle('Edit Page Blocks');

        // Set the global item var
        abcsetup.item = JSON.parse($('form.page_blocks #item_object').val());

        $(document).on("click","button.add-block", function() {
            var page_block_type = $(this).data("page-block-type");
            var page_block_max_global = $(this).data("page-block-max_global");
            var button_add = $(this);
            var promo_id = abcsetup.item.id ;
            if(page_block_max_global) {
                button_add.find('span').html('<i class="fas fa-spinner fa-spin"></i>');
                axios.post('/api/promo/page_block_reservations', {
                    page_block_type: page_block_type, 
                    form_action: 'add',
                    promo_id : promo_id,
                }).then(response => {
                    button_add.find('span').html('+');
                    if (response.data.error) {
                        abcsetup.alerts.show('Error', response.data.error);
                        console.log("ERROR: page_block_reservations[add]: "+response.data.error);
                    } else {
                        var reserv_timer_id =  abcsetup.promos.page_block.edit.create_page_block_reservations_update_timer(page_block_type,promo_id);
                        abcsetup.promos.page_block.edit.add_page_block(page_block_type,reserv_timer_id);
                        // alert('Added the reservation');
                    }  
                });
            } else {
                abcsetup.promos.page_block.edit.add_page_block(page_block_type);
                // alert('Added the PB');
            }
        });

        $(document).on("click",".delete-page-block", function() {
            if ($(this).hasClass("disabled")) {
                alert("Page block cannot be deleted because it contains an item that has been submitted");
                return false;
            }
            
            var page_block = $(this).closest(".page_block");
            var page_block_id = page_block.data("page-block");
            var promo_id = abcsetup.item.id ;
            abcsetup.alerts.confirm('Delete Page Block', 'Are you sure you want to remove this page block?', function (resp) {
                abcsetup.item.deleted_page_blocks.push(page_block_id);
                page_block.find('.items_selected > ul > li').each(function(idx,li) {
                    // add items from deleted page block to all unselected lists
                    $('.items_unselected > ul').each(function(idx,ul) {
                        $(li).clone().appendTo($(ul));
                    });
                    if ($.inArray($(li).data('item').toString(),abcsetup.item.items_available) < 0) {
                        abcsetup.item.items_available.push($(li).data('item').toString());
                    }
                    if ($.inArray($(li).data('item').toString(),abcsetup.item.items_selected) > -1) {
                        abcsetup.item.items_selected.splice($.inArray($(li).data('item').toString(),abcsetup.item.items_selected),1);
                    }
                    console.log("items_selected->"+JSON.stringify(abcsetup.item.items_selected,{},4));
                });
                page_block.remove();
                abcsetup.promos.page_block.edit.delete_promo_plan_reservation(page_block.data("page-block-type") ,promo_id, page_block.data("reserv-id"));
            });
        });

        $(document).on("click","#save", function() {
            var page_block_items = {};
            var page_block_comments = {}; 
            var page_blocks_attachments = {}; 
            var promo_id = abcsetup.item.id ;
        
            //FIXME: invalid ? 
            $(".page_block").find("div.page_block_comment .comment").removeClass('invalid');
            $(".page_block").find("div.page_block_comment .invalid").hide();
        
            $("div.page_block").each(function() {
                var page_block = $(this).data("page-block");
                var page_block_type = $(this).data("page-block-type");
                page_block_items[page_block] = {type : page_block_type, items : [], attachments : []};
                $(this).find(".items_selected > ul > li").each(function() {
                    var item = $(this).data("item");
                    page_block_items[page_block].items.push(item);
                });
                console.log('page_block->',page_block); 
                $(this).find("input[name='page_block_attachments["+page_block+"][]']").each(function() {
                    // console.log('this->',$(this)); 
                    var attachment = $(this).val();
                    page_block_items[page_block].attachments.push(attachment);
                    // console.log('attachments->',attachments);
                });
                page_blocks_attachments[page_block] = page_block_items[page_block].attachments;
                console.log("attachments->"+page_block+"->"+JSON.stringify(page_blocks_attachments,{},4));
                page_block_comments[page_block] = $(this).find("div.page_block_comment .comment").val();
                if(!page_block_comments[page_block] && $(this).find("div.page_block_comment .comment").is(':visible')) {
                    $(this).find("div.page_block_comment .comment").addClass('invalid');
                    $(this).find("div.page_block_comment .invalid").show();
                }
        
            });
        
            console.log("page_block_items->"+JSON.stringify(page_block_items,{},4));
            console.log("page_blocks_attachments->"+JSON.stringify(page_blocks_attachments,{},4));

            // FIXME: Prevent user from saving if there is an error on the page
            if($("div.page_block").find("div.page_block_comment .comment.invalid").length) {
                abcsetup.alerts.show('Error', 'There are errors on this page. Please review the fields highlighted in Red.');
                return;
            }
            
            axios.post('/promo/'+promo_id+'/page_blocks',{
                form_action: "update",
                page_block_items: page_block_items,
                page_block_attachments: page_blocks_attachments,
                deleted_page_blocks: abcsetup.item.deleted_page_blocks,
                page_block_comments: page_block_comments
            }).then(response => { 
                if (response.data.error) {
                    abcsetup.alerts.show('Error', response.data.error);
                    console.log("ERROR: page_blocks[save]: "+response.data.error);
                } else {
                    window.location.href= response.request.responseURL; 
                }
            }).catch(error => {
                abcsetup.alerts.show('Error', error.response.data.error);
                console.log("ERROR: page_blocks[save]: "+error.response.data.error);
            });
        });

        //console.log('page_block: ',abcsetup.item.page_blocks);

        for (var page_block in abcsetup.item.page_blocks ) {
            console.log('page_block: ',abcsetup.item.page_blocks[page_block].id);
            this.select_items(abcsetup.item.page_blocks[page_block].id);
        }   
        //$Promo->PageBlock
    },  
    select_items : function(id) {
        // console.log('select_items: ',id);
        // click event to move items from unselected to selected list
        $('.items_unselected > ul.page_block_'+id).on('click','li',function(event) {
            var page_block = $(this).closest(".page_block");
            var items_selected_ul = page_block.find('.items_selected > ul');
            var max_items = page_block.data('max-items');
            var max_items_hard = page_block.data('max-items-hard');
            var num_selected_items = items_selected_ul.children('li').length;
            var num_items_open = max_items - (num_selected_items + 1);
            if (num_items_open < 0 && max_items_hard == 1) {
                return;
            }
            else if (num_items_open == 0) {
                if (max_items_hard == 1) {
                    page_block.find('.num_items_selected').addClass('alert');
                }
                else {
                    page_block.find('.num_items_selected').addClass('warn');
                }
            }
            page_block.find('.num_items_selected').html(num_selected_items + 1);
            var selected_item = $(event.target).data('item');
            console.log("add item->["+selected_item+"]");
            $(event.target).attr("title",'Click to remove item from the Selected Page Block Items list').appendTo(items_selected_ul);
            // remove from all ul.items_unselected
            $('.items_unselected > ul > li').each(function(idx,li) {
                if ($(li).data('item').toString() == selected_item.toString()) {
                    $(li).remove();
                }
            });
            if ($.inArray(selected_item.toString(),abcsetup.item.items_selected) < 0) {
                abcsetup.item.items_selected.push(selected_item.toString());
            }
            if ($.inArray(selected_item.toString(),abcsetup.item.items_available) > -1) {
                abcsetup.item.items_available.splice($.inArray(selected_item.toString(),abcsetup.item.items_available),1);
            }
            // console.log("items_available->"+JSON.stringify(abcsetup.item.items_available,{},4));
            // console.log("items_selected->"+JSON.stringify(abcsetup.item.items_selected,{},4));
        });
        // click event to move items from selected to unselected list
        $('.items_selected > ul.page_block_'+id).on('click','li',function(event) {
            if ($(this).hasClass("vendor_uneditable")) {
                alert("This item has already been submitted and may not be removed from the ad block.");
                return;
            }
            var page_block = $(this).closest(".page_block");
            var selected_item = $(event.target).data('item');
            var items_selected_ul = page_block.find('.items_selected > ul');
            var max_items = page_block.data('max-items');
            var block_type = page_block.data('page-block-type');
            var num_selected_items = items_selected_ul.children('li').length;
            var num_items_open = max_items - (num_selected_items - 1);
            if (num_selected_items - 1 < max_items) {
                page_block.find('.num_items_selected').removeClass('alert').removeClass('warn');
            }
            page_block.find('.num_items_selected').html(num_selected_items - 1);
            console.log("remove item->["+selected_item+"]");
            $(event.target).attr("title",'Click to add item from the Selected Page Block Items list').detach();
            // add to all ul.items_unselected
            $('.items_unselected > ul').each(function(idx,ul) {
                $(event.target).clone().appendTo($(ul));
            });
            $(event.target).remove();
            if ($.inArray(selected_item.toString(),abcsetup.item.items_available) < 0) {
                abcsetup.item.items_available.push(selected_item.toString());
            }
            if ($.inArray(selected_item.toString(),abcsetup.item.items_selected) > -1) {
                abcsetup.item.items_selected.splice($.inArray(selected_item.toString(),abcsetup.item.items_selected),1);
            }
            // console.log("items_available->"+JSON.stringify(abcsetup.item.items_available,{},4));
            // console.log("items_selected->"+JSON.stringify(abcsetup.item.items_selected,{},4));
        });
    },

    create_page_block_reservations_update_timer: function(page_block_type,promo_id) {
        interval_id = setInterval(function() {
            axios.post('/api/promo/page_block_reservations', {
                page_block_type: page_block_type, 
                form_action: 'update',
                promo_id : promo_id,
            }).then(response => {
                if (response.data.error) {
                    console.log("ERROR: page_block_reservations[update]: "+response.data.error);
                }  
            });
            },240000); 
        return interval_id;
    },

    add_page_block : function (type,reserv_timer_id=null) {
        var rand_id = 'new_'+Math.floor((Math.random()*1000) + 1);
        var ul_unselected = $('<ul class="connected_sortable page_block_'+rand_id+'"/>');
        for (var idx in abcsetup.item.items_available) {
            var item_id = abcsetup.item.items_available[idx];
            // console.log('Foo:',abcsetup.item.promo_items.filter(obj=>{ return obj.item==item_id}));
            if (abcsetup.item.items_selected.indexOf(item_id) == -1) {
                ul_unselected.append('<li data-item="'+item_id+'" class="ui-state-default" title="Click to add item to the Selected Page Block Items list">'+abcsetup.item.promo_items.filter(obj=>{ return obj.item==item_id})[0].a_b_c_item.mat_descr+'</li>');
            }
        }
        var page_block = $('<div class="card shadow-sm page_block '+(abcsetup.item.page_block_types.filter(obj=>{ return obj.page_block_type==type})[0].page_block_type_ref.max_global ? "max_global" : "")+'" data-page-block="'+rand_id+'" data-page-block-type="'+type+'" data-max-items="'+abcsetup.item.page_block_types.filter(obj=>{ return obj.page_block_type==type})[0].page_block_type_ref.max_items+'" '+(reserv_timer_id ? ' data-reserv-id="'+reserv_timer_id+'"' : '' )+' />');
    
        var header = $('<div class="header row ml-1 mr-0 pb-1"/>');
        var title = $('<div class="title"/>').append(
            '<h5 class="mb-0 pt-1 pb-1 font-weight-bold">'+abcsetup.item.page_block_types.filter(obj=>{ return obj.page_block_type==type})[0].page_block_type_ref.name+' : '+(abcsetup.item['cost_'+type] ? '$'+abcsetup.item['cost_'+type] : abcsetup.item['cost_'+type+'_ad'] ? '$'+abcsetup.item['cost_'+type+'_ad'] : 'refer to price-list for cost')+'</h5>'+
            '<div class="pt-1">'+
                '<span class="btn btn-danger delete-page-block" title="Delete the Page Block">'+
                    'Delete'+
                '</span>'+
            '</div>'
        );
        header.append(title);
        var max_items_hard = 'Recommended max.';
        if (abcsetup.item.page_block_types.filter(obj=>{ return obj.page_block_type==type})[0].page_block_type_ref.max_items_hard == 1) {
            max_items_hard = 'Max.';
        }
        var num_items_selected_container = $('<div class="num_items_selected_container"/>').append(
            '<span class="num_items_selected" title="Number of selected items">0</span>'
        );
        header.append(num_items_selected_container).appendTo(page_block);
        var properties = $('<div class="properties"/>').append(
            max_items_hard+' items #<br/><b>'+abcsetup.item.page_block_types.filter(obj=>{ return obj.page_block_type==type})[0].page_block_type_ref.max_items+'</b>'
        );
        header.append(properties);
        
        var main_focus_of_ad = ''; 
        if( abcsetup.item.type=='rr' || abcsetup.item.type=='rr2' ) {
            main_focus_of_ad =  $('<div class="page_block_comment"/>').append(
                '<textarea cols="50" placeholder="Please add the reason/main focus of your ad" title="Please add the reason/main focus of your ad" rows="4" class="comment required form-control" data-page-block="'+rand_id+'" data-page-block-type="'+type+'" required ></textarea>'+
                '<span class="text-danger font-weight-bold">*</span>'
            );
        }
    
        header.append(main_focus_of_ad);
        var row = $('<div class="row m-0"/>');
        var items = $('<div class="items float-left pt-2 col-md-6"/>');
        var items_row = $('<div class="row"/>').appendTo(items);
        var div_items_unselected = $('<div class="items_unselected col-md-6 m-0"/>').appendTo(items_row);
        div_items_unselected.append("<h6>Available Promotion Items</h6>");
        div_items_unselected.append(ul_unselected);
        var div_items_selected = $('<div class="items_selected col-md-6 m-0"/>').appendTo(items_row);
        div_items_selected.append("<h6>Selected Page Block Items</h6>");
        div_items_selected.append('<ul class="connected_sortable page_block_'+rand_id+'"/>');
        row.append(items);
        var attachment_div = $('<div class="item_attachments attachments float-left pt-2 col-md-5"></div>');
        // Replace __ID__ with rand_id
        attachments_html = $("#default_page_block_attachments").clone().show().html();
        attachments_html = abcsetup.replaceAll(attachments_html, '__ID__', rand_id);
        attachment_div.append(attachments_html);
        row.append(attachment_div);
        page_block.append(row);
        $(".promo_page_block .page_block_section_heading").after(page_block);
        abcsetup.promos.page_block.edit.select_items(rand_id);
        
    },
    delete_promo_plan_reservation : function (page_block_type,promo_id,reserv_id) {
        var num_reserved_page_blocks = $('.max_global').length
        axios.post('/api/promo/page_block_reservations',{
            page_block_type: page_block_type,
            form_action: "delete",
            promo_id : promo_id
        }).then(response => {
            if (response.data.error) {
                abcsetup.alerts.show('Error', response.data.error);
                console.log("ERROR: page_block_reservations[delete]: "+response.data.error);
            } 
        });

        clearInterval(reserv_id);
    }
}